"use client";
import { AppBar, Container, styled } from "@mui/material";
import { PropsWithChildren, useEffect } from "react";
import { useScrollOffSetTop } from "@onair/minimal-ui/hooks/use-scroll-offset-top";
import { useRef } from "react";
import { cn } from "@onair/utils/cn";
import { useParams, usePathname } from "next/navigation";

const HEADER_PADDING = 32;

interface HeaderWraperProps extends PropsWithChildren {}
const HeaderWraper: React.FC<HeaderWraperProps> = ({ children }) => {
	const headerRef = useRef<HTMLHeadElement>(null);
	const headerHeight = useRef(0);
	const pathname = usePathname();

	const isHomepage = pathname === "/";

	const { elementRef, offsetTop: isReachOffsetTop } = useScrollOffSetTop(
		isHomepage ? headerHeight.current + HEADER_PADDING : headerHeight.current,
	);

	useEffect(() => {
		const headerNode = headerRef.current;
		headerHeight.current = headerNode?.getBoundingClientRect().height || 0;
	}, []);

	return (
		<StyledAppbar
			ref={headerRef}
			position="relative"
			className={cn("header-wraper z-[99]", {
				"is-fixed": isReachOffsetTop,
				"is-homepage": isHomepage,
				"bg-white border-b": !isHomepage,
			})}
			sx={{
				height: isReachOffsetTop ? `${headerHeight.current}px` : "auto",
				"@media only screen and (min-width: 1200px)": {
					top: isHomepage ? `${HEADER_PADDING}px` : "auto",
				},
			}}
		>
			<div className={cn("header-wraper__inner transition-all")}>
				<Container>{children}</Container>
			</div>
		</StyledAppbar>
	);
};
export default HeaderWraper;

const StyledAppbar = styled(AppBar)`
	&.header-wraper {
		background-color: white;
		width: 100%;

		.header-row {
			padding: 16px 0px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			background: white;
			border-radius: 12px;
		}
		&.is-fixed {
			.header-row {
				background: transparent;
				border-radius: 16px;
			}
			.header-wraper__inner {
				position: fixed;
				background: white;
				top: 0;
				left: 0;
				right: 0;
				z-index: 999;
				box-shadow: 0px 4px 12px rgb(0 0 0 / 8%);
			}
		}
		@media only screen and (min-width: 1200px) {
			background-color: transparent;
			.header-row {
				padding: 20px 16px;
			}
		}
	}
`;
